export const initScrollableNavigation = (containerSelector = '.categoryList--scrollable') => {
    const nav = document.querySelector(containerSelector);
    const navList = nav?.querySelector('.categoryList__nav');
    if (!nav || !navList) return;

    const prevArrow = document.createElement('button');
    const nextArrow = document.createElement('button');

    const createArrows = () => {
        prevArrow.className = 'nav-arrow nav-arrow--prev';
        nextArrow.className = 'nav-arrow nav-arrow--next';

        prevArrow.innerHTML = '<i class="icon icon-arrow-left" aria-hidden="true">';
        nextArrow.innerHTML = '<i class="icon icon-arrow-right" aria-hidden="true">';

        nav.parentNode.insertBefore(prevArrow, nav);
        nav.parentNode.insertBefore(nextArrow, nav.nextSibling);
    };

    const scroll = (direction) => {
        const items = Array.from(navList.querySelectorAll('li'));
        if (items.length === 0) return;

        const containerWidth = nav.clientWidth;
        const containerCenter = nav.scrollLeft + (containerWidth / 2);

        let targetItem;

        if (direction === 'next') {
            // Finde das erste Element, dessen Mitte rechts von der Container-Mitte liegt
            targetItem = items.find(item => {
                const itemCenter = item.offsetLeft + (item.offsetWidth / 2);
                return itemCenter > containerCenter + 1; // +1 als Puffer für Rundungsfehler
            });
            // Wenn kein nächstes gefunden wurde, nimm das letzte
            if (!targetItem) targetItem = items[items.length - 1];
        } else {
            // Finde das letzte Element, dessen Mitte links von der Container-Mitte liegt
            targetItem = [...items].reverse().find(item => {
                const itemCenter = item.offsetLeft + (item.offsetWidth / 2);
                return itemCenter < containerCenter - 1;
            });
            // Wenn kein vorheriges gefunden wurde, nimm das erste
            if (!targetItem) targetItem = items[0];
        }

        if (targetItem) {
            const targetScrollLeft = targetItem.offsetLeft - (containerWidth / 2) + (targetItem.offsetWidth / 2);

            nav.scrollTo({
                left: targetScrollLeft,
                behavior: 'smooth'
            });
        }
    };
    const updateArrowsVisibility = () => {
        const scrollLeft = nav.scrollLeft;
        const maxScroll = nav.scrollWidth - nav.clientWidth;

        prevArrow.style.display = scrollLeft > 0 ? 'block' : 'none';
        nextArrow.style.display = scrollLeft < maxScroll ? 'block' : 'none';

        // Fade-Effekt Klassen auf dem äußeren Container
        nav.closest('.categoryList').classList.toggle('show-prev', scrollLeft > 0);
        nav.closest('.categoryList').classList.toggle('show-next', scrollLeft < maxScroll);
    };


    const checkScrollability = () => {
        const isScrollable = nav.scrollWidth > nav.clientWidth;

        prevArrow.style.display = 'none';
        nextArrow.style.display = isScrollable ? 'block' : 'none';

        nav.classList.toggle('is-scrollable', isScrollable);

        // Wenn scrollbar, dann initial den rechten Overlay anzeigen
        const categoryListContainer = nav.closest('.categoryList');
        categoryListContainer.classList.toggle('show-next', isScrollable);
    };

    // Initialisierung
    createArrows();

    // Event Listener
    prevArrow.addEventListener('click', () => scroll('prev'));
    nextArrow.addEventListener('click', () => scroll('next'));
    nav.addEventListener('scroll', updateArrowsVisibility);
    window.addEventListener('resize', checkScrollability);

    // Initial Check
    checkScrollability();

    // Return cleanup function
    return () => {
        prevArrow.remove();
        nextArrow.remove();
        window.removeEventListener('resize', checkScrollability);
    };
};
